import dateFormatter from "utils/formatter-utils/date-formatter";
import { formatAsCurrency } from "utils/formatter-utils/currency-formatter";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";
import BlockyMediumText from "components/custom-texts/blocky-medium-text";
import StatusBadge from "components/status-badge";
import styles from "./styles.module.css";
import { secondaryColor, sparketBlack } from "utils/constants";
import { useState } from "react";
import RulesModal from "./rules-modal";
import Outcome from "./outcome";
import { Button } from "react-bootstrap";
import { BetTypeName } from "interfaces/bet-type-name";
import { useNavigate } from "react-router-dom";
import { Contest } from "interfaces/leaderboard/contest.ts";
import { PoolDetailsResponse } from "interfaces/pool-details-response.ts";

interface PoolSummaryProps {
  pool: PoolDetailsResponse;
  backUrl?: string;
  betType?: BetTypeName;
  contest?: Contest;
}

const PoolSummary = ({ pool, backUrl, betType, contest }: PoolSummaryProps) => {
  const [showRulesModal, setShowRulesModal] = useState(false);
  const navigate = useNavigate();

  const contestAndPhaseName = () => {
    const optionalPhaseName = (contest: Contest) => {
      const phaseName = pool.phase_id ? (contest.phases ?? []).find(p => p.id == pool.phase_id)?.name : "";
      if (phaseName !== undefined && phaseName !== "") {
        return ": " + phaseName;
      }
      return "";
    };

    return <>
      {contest &&
        <BlockyHeavyText className={styles.titleText}>
          {contest.name}{optionalPhaseName(contest)}
        </BlockyHeavyText>
      }
    </>;
  };

  return (
    <>
      <RulesModal
        pool={pool}
        showRulesModal={showRulesModal}
        setShowRulesModal={setShowRulesModal}
      ></RulesModal>
      <div className={styles.poolSummarySection}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            style={{
              backgroundColor: secondaryColor,
              borderColor: secondaryColor,
              color: sparketBlack,
              borderRadius: 5,
            }}
            onClick={() => {
              if (backUrl) {
                navigate(backUrl);
              } else {
                navigate("/");
              }
            }}
          >
            <BlockyHeavyText customStyles={{ fontSize: 14 }}>
              &lt; Back
            </BlockyHeavyText>
          </Button>
          {betType &&
            <div style={{ margin: 8 }}>
              <BlockyHeavyText className={styles.activeBetsText}>
                Pool Size:&nbsp;
              </BlockyHeavyText>
              <BlockyHeavyText className={styles.totalText}>
                {formatAsCurrency(pool[(`total_${betType}`) as keyof PoolDetailsResponse] as number ?? 0)}
              </BlockyHeavyText>
            </div>
          }
          <div style={{ alignSelf: "center" }}>
            <StatusBadge status={pool.status} is_bet={false} />
          </div>
        </div>
        <BlockyHeavyText
          className={styles.titleText}
          style={{ color: "var(--secondary-color)", fontSize: 22 }}
        >
          {pool.event_name && pool.event_name + ": "}
          {pool.name}
        </BlockyHeavyText>
        {contestAndPhaseName()}
        <BlockyMediumText className={styles.poolStartText}>
          Closes: {dateFormatter(pool.close)}
        </BlockyMediumText>
        <div className={styles.winConditionContainer}>
          <BlockyMediumText className={styles.winConditionText}>
            Win Condition: {pool.win_condition}
          </BlockyMediumText>
        </div>
        <div
          style={{ color: "var(--secondary-color)" }}
          onClick={() => {
            setShowRulesModal(true);
          }}
        >
          <BlockyMediumText
            style={{ cursor: "pointer", textDecoration: "underline" }}
          >
            See Full Rules
          </BlockyMediumText>
        </div>
        <Outcome pool={pool} />
      </div>
    </>
  );
};

export default PoolSummary;
